export { default } from "./SchoologyIcon";
